import type { z } from 'zod'

import { useApis } from '@/legacy-src/contexts/api-context'

import { GetDiagnosisResponseSchema } from '@/src/domains/diagnosis/schemas'
import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const useGetDiagnosis = <Config extends SwrQueryOptions<z.infer<typeof GetDiagnosisResponseSchema>> | undefined>(
  serviceId?: number,
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    [serviceId, 'diagnosis', 'GET'],
    async () => {
      const { data } = await api.getDiagnosis(serviceId)

      return GetDiagnosisResponseSchema.parse(data)
    },
    options,
  )
}
